import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { DateTime } from 'luxon';
import { ChancenwerkUser } from '../../master-data-management/users/entities/ChancenwerkUser.js';

@Entity()
export class Comment extends MongoEntity {
  static override _class = 'Comment';
  static override _collectionName = 'comments';

  @Field(() => DateTime)
  createdAt: Maybe<DateTime>;

  @Field(() => String)
  userID: Maybe<string>;

  @DataLoadedField(() => ChancenwerkUser, ({ userID }) => userID)
  user: Maybe<ChancenwerkUser>;

  @Field(() => String)
  roomID: Maybe<string>;

  @Field(() => String)
  text: Maybe<string>;
}
